export default __webpack_public_path__ + "static/media/the-villa5.cf485ec1.webp";